function cloneRows(rows) {
  return (rows || []).map((row) => ({
    id: row.id ?? null,
    contactValue: row.contactValue || "",
    isActive: Number(row.isActive) === 1 || row.isActive === true,
  }));
}

function toggleActive(rows, index) {
  const next = cloneRows(rows);
  if (!next[index]) return next;
  const activeCount = next.filter((row) => row.isActive).length;
  if (next[index].isActive && activeCount <= 1) return next;
  next.forEach((row, rowIndex) => {
    row.isActive = rowIndex === index;
  });
  return next;
}

function canCheckPrimary({ isActive, primaryBlocked, leaseCurrent }) {
  return Boolean(isActive) && !primaryBlocked && Boolean(leaseCurrent);
}

function rowAfterDelete(rows, index) {
  const next = cloneRows(rows);
  if (index < 0 || index >= next.length) return next;
  const removed = next.splice(index, 1)[0];
  if (!next.length) return next;
  if (removed && removed.isActive && !next.some((row) => row.isActive)) {
    next[Math.min(index, next.length - 1)].isActive = true;
  }
  return next;
}

function addEmailRow(rows) {
  const next = cloneRows(rows);
  next.push({
    id: null,
    contactValue: "",
    isActive: next.length === 0,
  });
  return next;
}

function splitAddresses(value) {
  return String(value || "")
    .split(/[,;]/)
    .map((part) => part.trim())
    .filter(Boolean);
}

function isSendable(value) {
  const email = String(value || "").trim().toLowerCase();
  return email.includes("@") && !email.endsWith("@noemail.com");
}

function rowsFromPerson(person) {
  if (person && Array.isArray(person.emailRows) && person.emailRows.length) {
    return person.emailRows;
  }
  return splitAddresses(person && person.email).map((contactValue, index) => ({
    id: null,
    contactValue,
    isActive: index === 0,
  }));
}

function activeAddressFromPerson(person) {
  const rows = rowsFromPerson(person);
  const sendable = rows.filter((row) => isSendable(row.contactValue));
  if (!sendable.length) return "";
  const marked = sendable.filter(
    (row) => Number(row.isActive) === 1 || row.isActive === true,
  );
  if (marked.length) return marked[0].contactValue;
  if (rows.some((row) => Number(row.isActive) === 1 || row.isActive === true)) {
    return "";
  }
  return [...sendable].sort((a, b) =>
    a.contactValue.localeCompare(b.contactValue, undefined, {
      sensitivity: "base",
    }),
  )[0].contactValue;
}

function leaseSendAddresses(people) {
  const prepared = (people || []).map((person) => ({
    isPrimaryTenant: Number(person.isPrimaryTenant) === 1,
    active: activeAddressFromPerson(person),
  }));
  const primary = prepared.find(
    (person) => person.isPrimaryTenant && person.active,
  );
  const chosen = primary
    ? [primary]
    : prepared.some((person) => person.isPrimaryTenant)
      ? prepared.filter((person) => !person.isPrimaryTenant && person.active)
      : prepared.filter((person) => person.active);
  const seen = new Set();
  const emails = [];
  for (const person of chosen) {
    const key = person.active.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    emails.push(person.active);
  }
  return emails;
}

module.exports = {
  cloneRows,
  toggleActive,
  canCheckPrimary,
  rowAfterDelete,
  addEmailRow,
  activeAddressFromPerson,
  leaseSendAddresses,
};
